import React from 'react'
import { FormattedMessage } from 'react-intl'
import ConfirmationDialog from 'app/components/ConfirmationDialog'
import { isEmpty } from 'ramda'
import CancelButton from 'app/components/buttons/CancelButton'
import DangerousButton from 'app/components/DangerousButton'

export default (props) => {
  const {
    beaconToBeDeletedArray,
    open,
    setOpen,
    onCancel,
    onConfirm,
    isPending,
  } = props

  if (isEmpty(beaconToBeDeletedArray) || !open) return null

  return (
    <ConfirmationDialog
      open={open}
      setOpen={setOpen}
      title={<FormattedMessage id="beacon.notification.deletingDialog.title" />}
      body={<FormattedMessage id="beacon.notification.deletingDialog.body" />}
      CancelButton={
        <CancelButton onClick={onCancel}>
          <FormattedMessage id="action.cancel" />
        </CancelButton>
      }
      ConfirmButton={
        <DangerousButton onClick={onConfirm} isLoading={isPending}>
          <FormattedMessage id="action.delete" />
        </DangerousButton>
      }
    />
  )
}
